var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tn-tag",class:_vm.type ? 'tn-tag--' + _vm.type : ''},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }